/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Injectable } from '@angular/core';
import { environment } from './../../../environments/environment';

@Injectable()
export class UserConfigService {
  private userConfigData;

  /**
    * Creates an instance of UserConfigService.
    * @memberOf ConfigService
    */
  constructor() {
    this.userConfigData = {
      userProfile: {
        windowNameList: {
          values:
          [
            { label: '', value: '' },
            { label: 'Terminal Status', value: 'Terminal Status' },
            { label: 'Terminal Handling', value: 'Terminal Handling' },
            { label: 'Terminal Notes', value: 'Terminal Notes' },
            { label: 'Locomotive Data', value: 'Locomotive Data' },
            { label: 'Locomotive History', value: 'Locomotive History' },
            { label: 'Locomotive Notes', value: 'Locomotive Notes' },
            { label: 'Train Data', value: 'Train Data' },
            { label: 'Train Profile', value: 'Train Profile' },
            { label: 'Train History', value: 'Train History' },
            { label: 'Train Notes', value: 'Train Notes' },
            { label: 'Locomotive Status', value: 'Locomotive-Status Data' },
            { label: 'Yard and Local', value: 'Yard-Local Data' },
            { label: 'Outlying Points', value: 'Outlying-Points Data' },
            { label: 'Query View', value: 'Query-View Data' }
          ]
        },
      }
    };
  }

  /**
   * @returns
   * @memberOf UserConfigService
   */
  getUserConfigData() {
    return this.userConfigData;
  }
}
